import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class KbRecommendationService {

  kbRecommendationOpenEvent: EventEmitter<Object> = new EventEmitter();
  previewPageOpenEvent:  EventEmitter<Object> = new EventEmitter();
  previewPageCloseEvent: EventEmitter<Object> = new EventEmitter();
  ingestPageOpenEvent: EventEmitter<Object> = new EventEmitter();
  ingestEvent:  EventEmitter<Object> = new EventEmitter();
  dataChanged:  EventEmitter<Object> = new EventEmitter();
  strictRecommendation:  EventEmitter<Object> = new EventEmitter();
  SortRecommendation:  EventEmitter<Object> = new EventEmitter();
  SearchRecommendation:  EventEmitter<Object> = new EventEmitter();
  viewKbRecommendation: any = false;
  selectedTopicData: any;
  selectedFile: any;

  constructor(
    private http: HttpClient
  ) { }

  getSuggestedTopicFeatures(agentId, params) {
    return this.http.post(environment.image_parser_service_api + 'kb_recommendation/' + agentId + '/fetch_recommendations', params)
  }

  downloadRecommendation(agentId, params) {
    return this.http.post(environment.image_parser_service_api + 'kb_recommendation/' + agentId + '/download_recommendation', params);
  }


  getOccurrenceDetails(agentId, params) {
    return this.http.post(environment.image_parser_service_api + 'kb_recommendation/' + agentId + '/occurrence/statistics', params)
  }

  getAssociatedData(agentId, params) {
    return this.http.post(environment.image_parser_service_api + 'kb_recommendation/' + agentId + '/associated_data', params)
  }

  getRecommendedDocuments(agentId, params) {
    return this.http.post(environment.image_parser_service_api + 'kb_recommendation/' + agentId + '/fetch_documents', params);
  }

  ingestRecommendationContent(agentId, data) {
    return this.http.post(environment.kb_service_api + 'ontology_interface/' + agentId + '/ingest_content', data);
  }

  getRecommendationCount(agentId, topicName) {
    return this.http.get(environment.image_parser_service_api +  'kb_recommendation/' + agentId + '/recommendation/count?topic='
     + topicName)
  }

  getSimilarities(agentId, params) {
    return this.http.post(environment.va_service_api + 'agents/get_similarity/' + agentId, params)
  }

  public getFile(path: string) {
    const headers = new HttpHeaders({
      'Content-Type':  'text/plain',
    });
    return this.http.get(path, {
      headers,
      responseType: 'text'
    })
  }

}

